import { TUpdateDealerTier, TUpdateTierRankingPolicy } from '@src/modules'

import { request } from './config'

export const getDealerTierLadder = (token: string) =>
  request({ url: 'dealer-tier/admin/ladder', method: 'GET' }, { token })

export const updateDealerTier = (id: number, body: TUpdateDealerTier, token: string) =>
  request({ url: `dealer-tier/admin/ladder/${id}`, method: 'PUT', data: body }, { token })

export const getRankingPolicy = (year: number, token: string) =>
  request({ url: `dealer-tier/admin/ranking-policy/${year}`, method: 'GET' }, { token })

export const updateRankingPolicy = (year: number, body: TUpdateTierRankingPolicy, token: string) =>
  request({ url: `dealer-tier/admin/ranking-policy/${year}`, method: 'PUT', data: body }, { token })

export const publishRankingPolicy = (year: number, token: string) =>
  request({ url: `dealer-tier/admin/ranking-policy/${year}/publish`, method: 'POST' }, { token })
